module.exports = __webpack_public_path__ + "static/media/  (118).c4ea0bff.jpg";